export default "__VITE_ASSET__69131e69__"